import React from 'react';

export default function AboutPage() {
  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold mb-4 text-blue-400">About</h1>
      <p className="text-gray-300">This is a simple time tracking application built with React and Tailwind CSS.</p>
    </div>
  );
}
